import { combine, withCallback, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'
import { admin } from 'routes/route.map'

import EventAddComponent from './component'

export const EventAdd = combine(
  withContext(
    'adminEventService',
    ServicesContext,
    ({ adminEventService }) => adminEventService
  ),
  withCallback(
    'onSubmit',
    ({ adminEventService }, { history }) =>
      async (event) => {
        try {
          await adminEventService.createEvent(event)
          toaster.info('Event has been successfully created')
          history.push(admin.events())
        } catch (error) {
          // Determine the error message to show based on error response
          let errorMessage = 'Failed to create event';

          if (error.response) {
            // Handle known error responses
            const statusCode = error.response.status;

            if (statusCode === 403) {
              errorMessage = 'You do not have permission to create events. Please contact an administrator.';
            } else if (statusCode === 400) {
              // Try to extract specific validation errors if available
              const responseData = error.response.data;
              if (responseData?.message) {
                errorMessage = `Validation error: ${responseData.message}`;
              } else {
                errorMessage = 'Invalid event data. Please check your inputs.';
              }
            } else if (statusCode === 404) {
              errorMessage = 'Event creation endpoint not found. Please contact an administrator.';
            } else {
              errorMessage = `Server error (${statusCode}): ${error.message || 'Unknown error'}`;
            }
          }

          toaster.error(errorMessage);
        }
      },
    []
  )
)(EventAddComponent)
